const grandTotalFormula = (total, { qty_order, harga_kesepakatan }) =>
  Math.round(total + parseFloat(qty_order) * parseFloat(harga_kesepakatan));

export const calculatePageGrandTotal = (detail = []) =>
  detail?.reduce(grandTotalFormula, 0);

export const calculateGrandTotal = (detail = []) =>
  detail?.filter((e) => e.checked)?.reduce(grandTotalFormula, 0);
